import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { rates } from './config';
import { ZorgToeslagConfig } from './interface';

export class ZorgToeslag {
    
    tax: number;
    
    constructor(data: ZorgToeslagConfig) {
        const property = data.single ? 'withoutPartner' : 'withPartner';
        this.tax = new SingleTierTax(rates[property][data.year], data.income).tax;
    }
    
}
